import React, { useEffect } from 'react';

import { NOTIFICATION_TYPE } from 'featureLib/NotificationComponent';
import ExploreProducts from 'featureLib/ExploreProducts';

import PlansCarouselSlide from './PlansCarouselSlide/PlansCarouselSlide';

import './OrderSummary.scss';
import { getFromSessionStorage, scrollToTop, toTitleCase, getb2cSessionData, trackAnalytics, getBandwithValueInMbps } from 'common/utils/app.utils';
import { FEASIBILITY_RESPONSE, MODULE_ID, FEASIBILITY_STATUS_UNAUTH } from 'home/common/constants/constants';
import { getCurrentLead } from 'tokenGeneration/lead.util';
import { trackGTMSelectedPlan } from 'app-layout/utils';

const OrderSummary = (props) => {
  const { setEditButtonClick, updateActiveIndex, customerDetailsFormState, userFilledPincode } = props;

  const feasibilityData = getFromSessionStorage(MODULE_ID, FEASIBILITY_RESPONSE);
  const installationAddress = feasibilityData?.address?.addressString;
  const feasibilityStatus = feasibilityData?.feasibilityStatus;
  const leadData = getCurrentLead?.();

  const getNotificationType = () => {
    let notificationType = null;

    // ILL unauth will not have NOT_FEASIBLE status. We allow customers only for FEASIBLE status, else will be blocked.
    if (feasibilityStatus === FEASIBILITY_STATUS_UNAUTH.FEASIBLE) {
      notificationType = NOTIFICATION_TYPE.SUCCESS;
    } else {
      notificationType = NOTIFICATION_TYPE.WARNING;
    }

    return notificationType;
  };

  const getNotificationMessage = () => {
    let notificationMessage = null;

    if (feasibilityStatus === FEASIBILITY_STATUS_UNAUTH.FEASIBLE) {
      notificationMessage = (
        <span>
          NETWORK AVAILABILITY STATUS: <b>{toTitleCase(feasibilityStatus)}</b>
        </span>
      );
    } else {
      notificationMessage = <span>Thank you for your request for dedicated internet our team will contact you within 24hrs.</span>;
    }

    return notificationMessage;
  };

  useEffect(() => {
    scrollToTop();
    trackAnalytics({
      eVar0: 'b2b| dedicated internet| home page| feasibility| location access| address details| order summary',
      prop0: 'b2b| dedicated internet',
      prop14: leadData?.authorizedSignatory?.phoneNumber,
      prop35: leadData?.authorizedSignatory?.companyName,
      prop15: leadData?.authorizedSignatory?.email,
      prop17: leadData?.authorizedSignatory?.firstName,
      prop19: userFilledPincode,
      prop20: installationAddress,
      prop22: feasibilityStatus === FEASIBILITY_STATUS_UNAUTH.FEASIBLE ? 'Service Available' : 'Manual Check Required',
      eVar6: 'ql_lead_created'
    });
    if (feasibilityStatus !== FEASIBILITY_STATUS_UNAUTH.FEASIBLE) {
      trackGTMSelectedPlan(feasibilityData?.feasibilityConfidence, `${getBandwithValueInMbps(feasibilityData?.requestedBandwidth + 'Mbps')} Mbps`);
    }
  }, []);

  return (
    <>
      <div className="container">
        {feasibilityStatus && (
          <div className="static_notification notification_section">
            <div className="network-coverage">
              <div className={`coverageContent ${getNotificationType() ?? ''}`}>
                {feasibilityStatus === FEASIBILITY_STATUS_UNAUTH.FEASIBLE && (
                  <div className="checkmark_box">
                    <div className="check"></div>
                  </div>
                )}
                {getNotificationMessage()}
              </div>
            </div>
          </div>
        )}
        <div className="order_summary">
          <div className="order_head">
            <h2 className="heading">Order Summary</h2>
            <img
              src="https://assets.airtel.in/static-assets/iothub/assets/b2b-images/red-edit.svg"
              alt="Edit"
              role="button"
              onClick={() => {
                // setEditButtonClick(new Date().getTime());
                updateActiveIndex(2);
              }}
            />
          </div>
          <p className="order_sub_text">
            <span>Installation Address:</span> {installationAddress}
          </p>
        </div>
      </div>
      {feasibilityStatus === FEASIBILITY_STATUS_UNAUTH.FEASIBLE ? (
        <PlansCarouselSlide {...props} />
      ) : (
        <div className="container order_summary explore_section_container">
          <div className="explore_section">
            <h2 className="explore_head">Explore Other Products</h2>
            <ExploreProducts />
          </div>
        </div>
      )}
    </>
  );
};

export default OrderSummary;
